/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { createTheme, alpha } from '@mui/material/styles';
import { PROMETHEAN_TEXT_HEADER, PROMETHEAN_PURPLE_GRAPE, PROMETHEAN_PURPLE_PLUM, PROMETHEAN_FOCUS_SHADOW } from '../../../../styles/colors/colors';
export var EMBERS_TABLE_HEADER_SORT_ICON_HEIGHT = 40;
export var getTableCellTheme = function getTableCellTheme(_ref) {
  var height = _ref.height;
  return createTheme({
    components: {
      MuiTableCell: {
        styleOverrides: {
          root: {
            padding: 0,
            height: 48,
            position: 'relative',
            boxSizing: 'border-box',
            '.resizing-line': {
              cursor: 'col-resize',
              position: 'absolute',
              top: 0,
              right: 0,
              width: 4,
              borderRight: "2px solid ".concat(PROMETHEAN_PURPLE_GRAPE),
              height: '100%',
              opacity: 0,
              '&:hover,&.active': {
                opacity: 1,
                height: height
              }
            }
          }
        }
      },
      MuiTableSortLabel: {
        styleOverrides: {
          root: {
            wordBreak: 'break-word',
            color: PROMETHEAN_TEXT_HEADER,
            '.EmbersTable-Header-SortIcon-root': {
              width: 40,
              height: EMBERS_TABLE_HEADER_SORT_ICON_HEIGHT,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              flexShrink: 0,
              visibility: 'hidden',
              '&.EmbersTable-Header-SortIcon-active': {
                visibility: 'visible'
              }
            },
            '&:hover': {
              '.EmbersTable-Header-SortIcon-root': {
                visibility: 'visible',
                transform: 'rotate(180deg)',
                backgroundColor: alpha(PROMETHEAN_PURPLE_GRAPE, 0.1),
                border: "1px solid ".concat(PROMETHEAN_PURPLE_PLUM)
              }
            },
            '&.Mui-focusVisible': {
              '.EmbersTable-Header-SortIcon-root': {
                visibility: 'visible',
                transform: 'rotate(180deg)',
                backgroundColor: alpha(PROMETHEAN_PURPLE_GRAPE, 0.1),
                boxShadow: PROMETHEAN_FOCUS_SHADOW + ' inset',
                border: 'none'
              }
            }
          }
        }
      }
    }
  });
};